/**
 * RH-MENU — "o RH existe para esta pessoa, aqui e agora?"
 *
 * Duas metades, as duas decididas fora da tela: a FLAG (`MENU_RH_ENABLED`,
 * desligada por padrão) diz se o RH existe; o `podeAbrirRh` do `/auth/me` diz
 * se esta pessoa entra (diretoria, "Cuida do RH" ou líder — nunca a conta
 * compartilhada). Esconder o menu é conforto: quem barra é o servidor.
 */
import { useAuth } from '@/contexts/AuthContext';
import { useMyFeatureFlags } from '@/lib/feature-flags-store';

export function useRhNaTela(): { ligado: boolean; podeAbrir: boolean; carregando: boolean } {
  const { user } = useAuth();
  const { data, isLoading } = useMyFeatureFlags();
  const ligado = data?.flags?.MENU_RH_ENABLED ?? false;
  return { ligado, podeAbrir: ligado && !!user?.podeAbrirRh, carregando: isLoading };
}
